<p-toast position="bottom-center"></p-toast>
<ng-container *transloco="let t; read: 'ivr-table-editor'">
  <app-data-table
    [cols]="cols"
    [loading]="loading"
    [refreshClicked]="getDataWrapper"
    [selectedCols]="cols"
    [tableRows]="tableRows$"
    [translationScope]="'ivr-table-editor'"
  >
    <ng-container appDataTableColumnDef="edit">
      <th *appDataTableHeader>{{ t('colEdit') }}</th>
      <td *appDataTableCell="let rowData">
        <button
          class="p-button-rounded p-button-primary p-button-text"
          pButton
          type="button"
          [attr.aria-label]="t('colEdit')"
          (click)="openEditDialog(rowData)"
        >
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>
  </app-data-table>
  <app-progress-spinner *ngIf="loading"></app-progress-spinner>
</ng-container>
